import { useState, useEffect } from "react";
import { replace } from "connected-react-router";
import { SYSTEM_ERROR_LINK, HOME_LINK, LOGGED_OUT_LINK } from "./Http";
import { setAuthError } from "@store/userData/actions";
import { useDispatch } from "react-redux";

export const useGeneralErrorHandler = () => {
  const [errorCode, setErrorCode] = useState(0);
  const dispatch = useDispatch();
  useEffect(() => {
    if (errorCode) {
      switch (errorCode) {
        case 401:
          dispatch(setAuthError());
          dispatch(replace(LOGGED_OUT_LINK));
          break;
        case 400:
        case 404:
          dispatch(replace(HOME_LINK));
          break;
        case 500:
        case 502:
        case 503:
        case 504:
          dispatch(replace(SYSTEM_ERROR_LINK));
          break;
        default:
          break;
      }
      setErrorCode(0);
    }
  }, [errorCode, dispatch]);
  return setErrorCode;
};
